<p-table [value]="products" dataKey="id">
    <ng-template pTemplate="header">
        <tr>
            <th style="width: 3rem"></th>
            <th>Name</th>
            <th>Is Active</th>
            <th>Markup/Discount(%)</th>
            <th>Action</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-product let-expanded="expanded">
        <tr class="parentRow" *ngIf="product.name == discountGroupType" >
            <td class="action">
                <button type="button" pButton pRipple [pRowToggler]="product" 
                class="p-button-text p-button-rounded p-button-plain" 
                [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></button>
            </td>
            <td>{{product.name}}</td>
            <td colspan="2"></td>
            <td>
                <span class="btnBars p-mr-0" (click)="viewProducts(product)" 
                pTooltip="View" tooltipPosition="top">
                    <i class="pi pi-microsoft"></i>
                </span>
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="rowexpansion" let-product>
        <tr *ngFor="let child of product.childPriceTier">
            <td></td>
            <td>{{child.name}}</td>
            <td>{{child.statusId==statusConstants.ACTIVE?answertypeConstants.Yes:answertypeConstants.No}}</td>
            <td>{{child.markup}}%</td>
            <td class="action">
                <span class="btnBars p-mr-0" (click)="addTierToGroup(product,child)"
                pTooltip="Add" tooltipPosition="top">
                    <i class="pi pi-plus"></i>
                </span>
                <span class="btnBars p-mr-0" (click)="showEditPricing(child)" 
                pTooltip="Edit" tooltipPosition="top">
                    <i class="pi pi-pencil"></i>
                </span>
                <span class="btnBars p-mr-0" pTooltip="Delete" tooltipPosition="top" (click)="deleteGroup(product,child)">
                    <i class="pi pi-trash"></i>
                </span>
            </td>
        </tr>
    </ng-template>
</p-table>

<p-dialog header="Add Tier to Group" [(visible)]="displayAddTier" [modal]="true" [responsive]="true" [style]="{width: '80vw'}" [closable]="false">
    <div class="card">
        <p-table #dt [value]="pricingData"
         [paginator]="true" [totalRecords]="totalRecords" [rows]="pageSize" [showCurrentPageReport]="true"
         currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [first]=first
         selectionMode="multiple" [(selection)]="selectedTiersToGroup" dataKey="id">
            <ng-template pTemplate="caption">
                <div class="p-gird p-d-flex">
                    <div class="p-col-4">
                        <p-dropdown [options]="productChannels" [(ngModel)]="selectedTBChannel" 
                        optionLabel="name" appendTo="body"></p-dropdown>
                    </div>
                    <div class="p-col-4">
                        <p-dropdown [options]="category" optionLabel="name" appendTo="body" 
                        [(ngModel)]="selectedCategory" placeholder="Select Category" (onChange)="productByCate()"></p-dropdown>
                    </div>
                    <div class="p-col-4">
                        <input pInputText type="text" (ngModelChange)="changed($event,'account')" 
                        [(ngModel)]="searchValue" placeholder="Search..." />
                    </div>
                </div>
            </ng-template>
            <ng-template pTemplate="header">
                <tr [pSelectableRow]="product">
                    <th>Item No.</th>
                    <th>Item Details</th>
                    <th>Cost</th>
                    <th>Sale Price</th>
                    <th>Discount Tier</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-product let-rowIndex="rowIndex">
                <tr [pSelectableRow]="product" [pSelectableRowIndex]="rowIndex">
                    <td>{{product.itemNo}}</td>
                    <td>{{product.desc}}</td>
                    <td>{{product.cost}}</td>
                    <td>{{product.price}}</td>
                    <td>
                        <ng-container *ngFor="let s of product.tiers; let i = index;">
                            <span>{{s.name}}</span>
                            <span *ngIf="product.tiers.length > 1 && i !== product.tiers.length-1">,</span>
                        </ng-container>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
    <p-footer>
      <button type="button" pButton (click)="displayAddTier = false" label="Cancel" class="p-button-secondary"></button>
      <button type="button" pButton label="Add"></button>
    </p-footer>
</p-dialog>
